import React from 'react'
import {Link} from 'react-router-dom'

const tmpCount = 1234

const CategoryItem = ({category, to}) => (
  <Link to={to} className='searchMainCategories'>
    <span className='searchMainCategories-text'>
      {category.name}
    </span> <span className='searchMainCategories-number'>
      {tmpCount.toLocaleString('en-GB').replace(',', ' ')}
    </span>
  </Link>
)

const Categories = ({t, categories, mode}) => (
  <div className='productsList-categories'>
    {mode === 'fullSearchResults' ? (
      <h4>{t('Suggested')} <b>{t('sub-categories')}</b> {t('for you')}</h4>
    ) : mode === 'autocomplete' ? (
      <h4>{t('Search in these')} <b>{t('categories')}</b></h4>
    ) : (
      ''
    )}
    <div>
      <div>
        {categories?.map(e => (
          <CategoryItem
            key={e.categoryUuid}
            to={`/category/${e.alias}`}
            category={e}
          />
        ))}
      </div>
    </div>
  </div>
)

export default Categories
